/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
/**
 * Determines if a reference is a `String`.
 *
 * @param value Reference to check.
 */
// 入参无法明确知道类型，此处使用any代替。下同
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isString(value) {
    return typeof value === 'string';
}
/**
 * Determines if a reference is an `Array`.
 *
 * @param value Reference to check.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isArray(value) {
    return Array.isArray(value);
}
/**
 * Determines if a reference is a `Function`.
 *
 * @param value Reference to check.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Determines if a reference is defined.
 *
 * @param value Reference to check.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isDefined(value) {
    return typeof value !== 'undefined';
}

export { isArray as a, isFunction as b, isDefined as c, isString as i };
